import "./BoilerFeedPumpService.module.css";
import Header from "@/reusable_sections/Header";
import Boilerfeedhero from "./sections/Boilerfeedhero";
import Solutions from "./sections/Solutions";
import Serviceareas from "./sections/Serviceareas";
import PlumbingCall from "./sections/PlumbingCall";
import Footer from "@/reusable_sections/Footer";
export default function BoilerFeedPumpServicePage() {
  return <div>
      <Header />
      <Boilerfeedhero />
      <Solutions />
      <Serviceareas />
      <PlumbingCall />
      <Footer />
    </div>;
}